module.exports = __webpack_public_path__ + "static/media/circle_01.d8c23890.svg";